export default __webpack_public_path__ + "static/media/feature3.e138c971.png";